import {
  IFormSchema,
  LayoutElement,
  isColumnElement,
  isFieldElement,
  isSectionElement,
} from "@entaconsulting/form";

const deleteFieldDefinition = (schema: IFormSchema, keys: string[]): void => {
  const [currentKey, ...rest] = keys;

  const current = schema[currentKey];

  if (rest.length !== 0 && current.schema) {
    return deleteFieldDefinition(current.schema, rest);
  }

  delete schema[currentKey];
};

const searchAndDeleteFieldDefinitions = (
  schema: IFormSchema,
  deleted: LayoutElement
) => {
  if (isFieldElement(deleted)) {
    deleteFieldDefinition(schema, deleted.name.split("."));
  } else if (isColumnElement(deleted) || isSectionElement(deleted)) {
    deleted.elements.forEach((element: LayoutElement) =>
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      searchAndDeleteFieldDefinitions(schema, element)
    );
  } else return;
};

export default searchAndDeleteFieldDefinitions;
